// Generated from design/08. Do not edit by hand.
export const ADMIN_SCREEN_STATES = ["loading","cached","empty","offline","error","permission","restricted","processing","success","conflict","expired"] as const

export const adminContracts = [
  {
    "id": "SC-ADMIN-001",
    "path": "/overview",
    "endpoints": [
      "GET /admin/v1/session",
      "GET /admin/v1/overview",
      "POST /admin/v1/search"
    ],
    "actions": [
      "session.read",
      "overview.read",
      "resource.search"
    ],
    "fields": "principal/roles/scopes/grants/environment/build/permission_epoch；range/metric_version/panels；search type/exact value/case",
    "behavior": "session+overview query；Search=`resource.search` 且 type/value/case 合法",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "401 回 `/login`；退出清 session/query cache",
    "roles": "all, support/risk/privacy/finance；`session.read,overview.read,resource.search`",
    "testIds": [
      "T-OPS-001"
    ],
    "title": "运营总览",
    "group": "运营"
  },
  {
    "id": "SC-ADMIN-002",
    "path": "/operations/:id",
    "endpoints": [
      "GET /admin/v1/operations/{id}",
      "POST /admin/v1/operations/{id}/cancellations",
      "POST /admin/v1/operations/{id}/retries"
    ],
    "actions": [
      "operation.read",
      "operation.cancel",
      "operation.retry"
    ],
    "fields": "id/type/owner/status/progress/version/result/error/allowed_actions/terminal_at",
    "behavior": "query；Cancel=non-terminal+allowed；Retry=`failed_retryable`+allowed+original key",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "410 显示终态证据过期且不重建；409 刷新；退出回来源",
    "roles": "domain role；`operation.read,operation.cancel,operation.retry`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "操作详情",
    "group": "运营"
  },
  {
    "id": "SC-ADMIN-003",
    "path": "/users/:id",
    "endpoints": [
      "GET /admin/v1/users/{id}",
      "POST /admin/v1/users/{id}/sensitive-field-reveals",
      "POST /admin/v1/users/{id}/session-revocations",
      "POST /admin/v1/users/{id}/restriction-requests"
    ],
    "actions": [
      "user.read",
      "user.contact.reveal",
      "user.session.revoke",
      "user.restriction.request"
    ],
    "fields": "id/status/profile_masked/locale/country/risk/三个 epoch/active_session_count/最近20 active sessions+truncated/family/pet/latest subscription/active restrictions/current-session contact grants/safe case index/allowed_actions/version+ETag",
    "behavior": "query 只认 path canonical ID；Reveal=服务端 allowed+同 user/current session 未过期 email one-use grant+purpose+ticket+step-up；Revoke=服务端 allowed+勾选1..20条当前返回 session及各 version+ticket+step-up+current user ETag；Restrict=服务端 allowed+固定 type/scope 映射+300..2592000秒(login<=86400)+affected moderation case+reason code+current user version/restriction epoch+step-up，只创建 review_pending proposal",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "响应 strict closed parser，unknown/sensitive field、非法枚举/顺序/重复/越界/ETag 整页拒绝；reveal 失败/<=60秒到期/离页/authority变化立即销毁值；403 grant 缺失跳转申请 exact grant；409 清选择并重读；退出清详情、grant/reveal/operation；Restrict 不得本地显示为已生效限制",
    "roles": "support/risk/privacy；`user.read,user.contact.reveal,user.session.revoke,user.restriction.request`",
    "testIds": [
      "T-OPS-001"
    ],
    "title": "用户详情",
    "group": "用户与资产"
  },
  {
    "id": "SC-ADMIN-004",
    "path": "/families/:id",
    "endpoints": [
      "GET /admin/v1/families/{id}",
      "POST /admin/v1/families/{id}/consistency-checks",
      "POST /admin/v1/families/{id}/repair-proposals"
    ],
    "actions": [
      "family.read",
      "family.consistency.run",
      "family.repair.propose"
    ],
    "fields": "closed family/member/pet/active relation/safe timeline/最近20 check/version+双 epoch+ETag",
    "behavior": "strict query；Check=member_projection/relation_projection/all+current version/双 epoch；Propose=当前 succeeded check+exact digest+仅 rebuild member/relation projection+open ticket+step-up",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "unknown/sensitive/非法 pointer/重复/越界整页拒绝；409 清 check/proposal 并重读；不可安全判定或安全退出相关状态禁用修复；authority变化/退出清详情和 operation",
    "roles": "support/risk/privacy/ops；`family.read,family.consistency.run,family.repair.propose`",
    "testIds": [
      "T-REL-001"
    ],
    "title": "家庭详情",
    "group": "用户与资产"
  },
  {
    "id": "SC-ADMIN-005",
    "path": "/family-repair-proposals/:id",
    "endpoints": [
      "GET /admin/v1/family-repair-proposals/{id}",
      "POST /admin/v1/family-repair-proposals/{id}/approvals"
    ],
    "actions": [
      "family.read",
      "family.repair.execute"
    ],
    "fields": "immutable check+repair diff/proposer/approvers（含 permission epoch/MFA 时间审计证明，不含 session ID）/approval_requirements/operation/family version+privacy/ownership epoch before-after/result digest/version+ETag",
    "behavior": "strict query；Approve/Reject=服务端 allowed+本人 reviewer 角色对应 requirement=pending+非提案人+step-up+current version；只有两名不同 principal 互补 approve 执行 exact CAS",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "404 安全空态；separation/409 重读提案；stale/rejected 显示零 family effect；operation/root 不闭合显示失败而非成功；authority变化/退出清投影",
    "roles": "support/ops/risk；`family.read,family.repair.execute`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "家庭修复审批",
    "group": "用户与资产"
  },
  {
    "id": "SC-ADMIN-006",
    "path": "/pets/:id",
    "endpoints": [
      "GET /admin/v1/pets/{id}",
      "POST /admin/v1/pets/{id}/recalculation-requests"
    ],
    "actions": [
      "pet.read",
      "pet.recalculate.request"
    ],
    "fields": "closed family/stage/species+appearance config/resource versions/state bands+mood/self-care/rule versions/progress affinity band/tendency band/version+ETag/recalc preview",
    "behavior": "strict query；Dry-run=current `pet.state.1_0`+pet/state version+ticket；Submit=同 principal exact 10 分钟 preview ID/digest+current ETag且服务端 economic_effects 为空",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "unknown/raw numeric/XP/personality/preference 字段整页拒绝；stale/过期 preview 清空并重算；409 清 preview 重读；authority变化/退出清详情和预览；禁止个体加值",
    "roles": "support/ops；`pet.read,pet.recalculate.request`",
    "testIds": [
      "T-PET-001"
    ],
    "title": "宠物详情",
    "group": "用户与资产"
  },
  {
    "id": "SC-ADMIN-007",
    "path": "/assets/owners/:type/:id",
    "endpoints": [
      "GET /admin/v1/assets/owners/{type}/{id}",
      "POST /admin/v1/compensation-requests"
    ],
    "actions": [
      "asset.ledger.read",
      "compensation.request",
      "compensation.execute"
    ],
    "fields": "closed owner status/version+ETag；account wallets<=20；inventory<=100+truncated/catalog/resource/source/reserved+available；published compensation catalog+policy/item/UTC window/per-request/per-window/remaining；keyset ledger<=50+typed source/order/ticket/request+succeeded worker operation",
    "behavior": "strict query type=`account|family` + optional canonical catalog/cursor/limit；Request 仅 account=current owner/version/ETag+published non-paid account-ownable catalog+positive quantity<=policy 两层上限+4 个固定 reason+open ticket，只创建 budget reservation + review_pending request；无 execute 按钮/client method",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "unknown/敏感字段、非闭合 typed source/worker operation、非 UTC window、数量守恒或分页异常整页拒绝；无 published policy 隐藏申请且保持只读；409 预算/幂等/版本冲突清表单并重读 owner+ledger；401/403/authority 变化和退出清全部 owner/表单/分页数据",
    "roles": "support/finance；exact user/family `asset.ledger.read`；account support `compensation.request`；worker `compensation.execute` 仅读终态",
    "testIds": [
      "T-ECO-001"
    ],
    "title": "资产与流水",
    "group": "用户与资产"
  },
  {
    "id": "SC-ADMIN-008",
    "path": "/compensation-requests/:id",
    "endpoints": [
      "GET /admin/v1/compensation-requests/{id}",
      "POST /admin/v1/compensation-requests/{id}/approvals"
    ],
    "actions": [
      "asset.ledger.read",
      "compensation.approve"
    ],
    "fields": "closed request/beneficiary/catalog/budget/proposer/review expiry/approval requirements+timeline/typed operation/decision/account asset+ledger refs/cap/version",
    "behavior": "query+approved 状态详情轮询；Approve/Reject=非申请人+exact user scope+server pending finance/ops role+recent step-up+未终态；浏览器无 execute",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "404 安全空态；409/410 清决定并重读 request；reject/stale/expired 保留证据且无资产结果；authority 变化清 detail；退出回 exact owner",
    "roles": "support/finance/ops；`asset.ledger.read,compensation.approve`；worker 结果只读",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "补偿审批",
    "group": "用户与资产"
  },
  {
    "id": "SC-ADMIN-009",
    "path": "/config-drafts",
    "endpoints": [
      "GET /admin/v1/config-drafts",
      "POST /admin/v1/config-drafts"
    ],
    "actions": [
      "config.read",
      "config.draft.write"
    ],
    "fields": "type/key/base/schema/owner/status/version/cursor",
    "behavior": "query；Create=registered type/key/base/schema+schema valid",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "schema error 定位字段；退出回 overview",
    "roles": "product/content/ai/ops；`config.read,config.draft.write`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "配置草稿",
    "group": "配置"
  },
  {
    "id": "SC-ADMIN-010",
    "path": "/config-drafts/:id",
    "endpoints": [
      "GET /admin/v1/config-drafts/{id}",
      "PATCH /admin/v1/config-drafts/{id}",
      "POST /admin/v1/config-drafts/{id}/validations",
      "POST /admin/v1/config-validation-results/{id}/warning-acceptances",
      "POST /admin/v1/config-drafts/{id}/submissions"
    ],
    "actions": [
      "config.read",
      "config.draft.write",
      "config.validate",
      "config.warning.accept",
      "config.submit"
    ],
    "fields": "draft/diff/version/ETag/validation_digest/errors/warnings/warning_acceptance_digest/simulations/rollback_target/submission history",
    "behavior": "query；Save=editable+ETag；Validate=saved version；Accept=warning+reason；Submit=0 error+全部 warning 决定+current draft/content/validation digest 后生成 immutable submission",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "404 安全空态；409 三方 diff；任何保存使旧 submission 显式 superseded，不能沿用批准；退出保留服务端草稿",
    "roles": "product/content/ai/ops；`config.read,config.draft.write,config.validate,config.warning.accept,config.submit`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "配置编辑",
    "group": "配置"
  },
  {
    "id": "SC-ADMIN-011",
    "path": "/config-drafts/:id/review",
    "endpoints": [
      "GET /admin/v1/config-drafts/{id}/review",
      "POST /admin/v1/config-submissions/{id}/approvals"
    ],
    "actions": [
      "config.read",
      "config.approve"
    ],
    "fields": "immutable submission_no/draft_version/content/validation/warning/impact/rollback digests/diff/simulations/budget/submitter/approvals/separation state",
    "behavior": "query by submission；Approve/Reject=非提交人+required_role+提交的 content/validation digest current+step-up",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "草稿变化只标 submission superseded；审批请求仍绑定 submission ID 且不能批准新草稿；404/409 清审批输入；退出回 review queue",
    "roles": "approved reviewer；`config.read,config.approve`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "配置审批",
    "group": "配置"
  },
  {
    "id": "SC-ADMIN-012",
    "path": "/config-releases",
    "endpoints": [
      "GET /admin/v1/config-releases",
      "POST /admin/v1/config-releases",
      "POST /admin/v1/config-releases/{id}/rollbacks"
    ],
    "actions": [
      "config.read",
      "config.release",
      "config.rollback"
    ],
    "fields": "filters/cursor/approved immutable submission/config version/targeting/canary/schedule/status/stable target/incident/operation",
    "behavior": "query；Release=submission approvals/专业角色/digest/探针通过+step-up；Rollback=stable target+incident+reason",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "发布失败进 operation；回滚不改旧 release；submission/config digest 不同立即阻断；409 重读 release；退出回 config",
    "roles": "product/content/ai/ops；`config.read,config.release,config.rollback`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "配置发布",
    "group": "配置"
  },
  {
    "id": "SC-ADMIN-013",
    "path": "/orders/:id",
    "endpoints": [
      "GET /admin/v1/orders/{id}",
      "POST /admin/v1/orders/{id}/platform-refreshes",
      "POST /admin/v1/orders/{id}/fulfillment-retries"
    ],
    "actions": [
      "commerce.order.read",
      "commerce.platform.refresh",
      "commerce.fulfillment.retry"
    ],
    "fields": "order/platform facts/verification/fulfillment/entitlement/refund timeline",
    "behavior": "query；Refresh=ticket；Retry=failed fulfillment+original id+ticket+step-up；无设成功",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "provider timeout 看 operation；409 刷新 timeline；退出回 search",
    "roles": "support/finance；`commerce.order.read,commerce.platform.refresh,commerce.fulfillment.retry`",
    "testIds": [
      "T-COM-001"
    ],
    "title": "订单详情",
    "group": "商业"
  },
  {
    "id": "SC-ADMIN-014",
    "path": "/subscriptions",
    "endpoints": [
      "GET /admin/v1/subscriptions"
    ],
    "actions": [
      "commerce.order.read"
    ],
    "fields": "filters/cursor/user/order/platform/state/capability snapshot/events/updated_at",
    "behavior": "query only；详情跳 order",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "provider stale 显示事实时间；退出回 overview",
    "roles": "support/finance；`commerce.order.read`",
    "testIds": [
      "T-COM-003"
    ],
    "title": "订阅列表",
    "group": "商业"
  },
  {
    "id": "SC-ADMIN-015",
    "path": "/reconciliation-cases",
    "endpoints": [
      "GET /admin/v1/reconciliation-cases",
      "POST /admin/v1/reconciliation-cases/{id}/resolutions",
      "GET /admin/v1/reconciliation-statement-imports",
      "POST /admin/v1/reconciliation-statement-imports",
      "POST /admin/v1/finance-exports"
    ],
    "actions": [
      "commerce.reconciliation.read",
      "commerce.reconciliation.resolve",
      "finance.statement.import",
      "finance.export"
    ],
    "fields": "tabs cases/imports/exports；case/platform/environment/period/currency/delta/evidence/status/version；statement object/digest/parser/WORM/import counts；export type/metric definition/dimensions/purpose/operation",
    "behavior": "query cases/imports；Resolve=open+证据+结论；Import=上传已完成+digest/parser/period合法+step-up；Export=聚合类型+受控维度+purpose+step-up",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "重复 digest 回原 import；parser/period/WORM 失败不创建平台事实；409 重读 case；export URL 到期清理；退出保留筛选/operation ID",
    "roles": "finance/auditor；`commerce.reconciliation.read,commerce.reconciliation.resolve,finance.statement.import,finance.export`",
    "testIds": [
      "T-COM-001",
      "T-OPS-006"
    ],
    "title": "财务对账",
    "group": "商业"
  },
  {
    "id": "SC-ADMIN-016",
    "path": "/advertising/placements",
    "endpoints": [
      "GET /admin/v1/advertising/placements",
      "PATCH /admin/v1/advertising/placements/{key}",
      "GET /admin/v1/advertising/blacklists",
      "POST /admin/v1/advertising/blacklists",
      "POST /admin/v1/advertising/blacklists/{id}/revoke-requests",
      "POST /admin/v1/advertising/blacklist-revoke-requests/{id}/approvals",
      "POST /admin/v1/advertising/remediation-batches",
      "POST /admin/v1/advertising/remediation-batches/{id}/approvals"
    ],
    "actions": [
      "advertising.read",
      "advertising.config.write",
      "advertising.blacklist.execute",
      "advertising.blacklist.revoke",
      "advertising.remediation.propose",
      "advertising.remediation.approve"
    ],
    "fields": "tabs placements/waterfall/blacklists/remediation；typed provider route、country/client/age/consent/free-only/priority；blacklist revoke request/approvals/source decision history；remediation execution/item source/typed exploration-or-outfit grant",
    "behavior": "query；Save=两个 allowlisted placement+versioned route；Blacklist=事故启用；Revoke=先 request 后非 proposer approve；Remediate=typed dry-run+budget，terminal item 必须回绑同 batch terminal execution",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "无合法 route 普通玩法继续；blacklist 无 source decision 保持 active，最新 reject/stale/expired 可按 current ETag 重提；item 无同 batch execution 不显示终态；reject/stale 释放 failed session；预算/资格变化重算；409 拉最新；operation 可离页",
    "roles": "product/ops/finance/analyst/incident_commander/ops_reviewer；`advertising.read,advertising.config.write,advertising.blacklist.execute,advertising.blacklist.revoke,advertising.remediation.propose,advertising.remediation.approve`",
    "testIds": [
      "T-COM-005",
      "T-OPS-006"
    ],
    "title": "广告治理",
    "group": "商业"
  },
  {
    "id": "SC-ADMIN-017",
    "path": "/ai/strategies",
    "endpoints": [
      "GET /admin/v1/ai/strategies",
      "POST /admin/v1/ai/strategies"
    ],
    "actions": [
      "ai.strategy.read",
      "ai.strategy.write"
    ],
    "fields": "scene/locale/audience/latest draft validation/version+ETag/latest published config/release/model route+versions/output schema/quota binding/30d cost+token+run counts/30d fallback+safety+privacy+failure facts/fallback/version；存在 release 时展示配置与指标同 published version",
    "behavior": "bounded query；Create=closed schema、无密钥、canonical locale、published shared global+同 scene/audience 三层 quota、五道安全链、六类 template fallback 完整，只生成 unvalidated config draft",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "quota/schema error 回字段；无 published strategy 显示 Draft only 且指标为0；502 authority shape 清空旧行；离页 abort 请求与清表单；退出回 overview",
    "roles": "ai_safety/ops/auditor；`ai.strategy.read,ai.strategy.write`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "AI 策略",
    "group": "AI"
  },
  {
    "id": "SC-ADMIN-018",
    "path": "/ai/evaluations",
    "endpoints": [
      "GET /admin/v1/ai/evaluations",
      "POST /admin/v1/ai/evaluations",
      "POST /admin/v1/ai/generation-runs/{id}/source-reveals"
    ],
    "actions": [
      "ai.strategy.read",
      "ai.evaluation.run",
      "ai.source.reveal"
    ],
    "fields": "filters/cursor/strategy/dataset/run/status/report/gates/source ordinals/grant/operation",
    "behavior": "query；Run=strategy+authorized dataset；Reveal=failed sample+one-use grant+selected ordinals",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "404/权限变化移除 run；reveal 到期清 URL；run 失败进 operation；退出清证据",
    "roles": "ai_safety/ops/privacy；`ai.strategy.read,ai.evaluation.run,ai.source.reveal`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "AI 评测",
    "group": "AI"
  },
  {
    "id": "SC-ADMIN-019",
    "path": "/ai/rollbacks",
    "endpoints": [
      "GET /admin/v1/ai/rollbacks",
      "POST /admin/v1/ai/rollbacks"
    ],
    "actions": [
      "ai.strategy.read",
      "ai.rollback"
    ],
    "fields": "filters/cursor；current scope/current strategy+release+model tuple；stable immutable strategy+source release+exact passed evaluation；canonical incident；24h run/fallback/failure/token/cost impact；disabled AI kill-switch execution/snapshot；operation/applied receipt摘要/history；15m+post evaluation+quality/factuality+四类零风险+multi-region probe gates/aggregate",
    "behavior": "bounded query；Rollback=server allowed action+exact current tuple+passed stable id+同根未关闭incident+disabled kill-switch+step-up；POST只排队，control worker未配置保持queued且零release",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "queued可离页；409清选择并重读current/history；401/403/410或permission epoch变化清全部authority数据；错receipt/gate闭包整页失败；退出abort并清表单/operation，恢复跳转SC-ADMIN-039且本页不自动执行",
    "roles": "ai_safety/ops/auditor；`ai.strategy.read,ai.rollback`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "AI 回滚",
    "group": "AI"
  },
  {
    "id": "SC-ADMIN-020",
    "path": "/moderation/cases",
    "endpoints": [
      "GET /admin/v1/moderation-cases"
    ],
    "actions": [
      "moderation.case.read"
    ],
    "fields": "object type/risk/severity/status/assignment/SLA filters/cursor；case ID/minimal evidence version+count/machine digest presence+self-assigned/SLA policy+deadline/version+ETag/allowed actions",
    "behavior": "bounded query；Open 仅行与 session 都允许 exact `moderation.case.read`，跳 `SC-ADMIN-021`",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "401/403/410、permission epoch/data scope/action 变化立即 abort 并清行；非法 cursor 不保留旧页；退出清行回 overview",
    "roles": "risk；`moderation.case.read`",
    "testIds": [
      "T-OPS-001"
    ],
    "title": "审核队列",
    "group": "审核与客服"
  },
  {
    "id": "SC-ADMIN-021",
    "path": "/moderation/cases/:id",
    "endpoints": [
      "GET /admin/v1/moderation-cases/{id}",
      "POST /admin/v1/moderation-cases/{id}/decision-proposals"
    ],
    "actions": [
      "moderation.case.read",
      "moderation.decision.propose"
    ],
    "fields": "case object/risk/severity/status/relative assignment/current evidence version；每版 count/bytes/server digest；最近20条无管理员身份的 decision/version/ETag history；machine digest presence；SLA/case version/ETag/allowed actions；decision=`no_action|warning|content_remove`；canonical reason code",
    "behavior": "query；Propose=under_review+assigned mine+无active proposal+session exact scope/action+current evidence+case ETag+CSRF+idempotency；限制类处置继续由用户详情 restriction request workflow 承担",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "401/403/404/410、permission epoch/data scope/action/route变化立即 abort、清详情和草稿；409 evidence/case/assignment/active proposal stale 清决定并强制重读；cached/offline 禁止 mutation；退出回 queue",
    "roles": "risk；`moderation.case.read,moderation.decision.propose`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "审核详情",
    "group": "审核与客服"
  },
  {
    "id": "SC-ADMIN-022",
    "path": "/moderation/decision-proposals/:id/review",
    "endpoints": [
      "GET /admin/v1/moderation-decision-proposals/{id}",
      "POST /admin/v1/moderation-decision-proposals/{id}/reviews"
    ],
    "actions": [
      "moderation.case.read",
      "moderation.decision.execute"
    ],
    "fields": "safe case/current evidence aggregate/proposal kind+status/typed impact(case target或restriction type+scope kind+duration)/relative proposer+reviewer/review/queued execution/version/ETag/allowed actions",
    "behavior": "query；Approve/Reject=非 proposer 的 current risk_reviewer+exact case scope/current evidence+5m MFA+step-up+proposal ETag；approve 只排队 execution，reject 零 operation/业务副作用",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "404/exclusion/data scope fail closed；同人/authority 失败只读；409 清草稿并重读；approved queued 明示等待执行，只有 executed 可显示已执行；permission epoch/action/scope/route/离页立即 abort 并清详情、step-up、草稿，返回 case",
    "roles": "risk/risk_reviewer；`moderation.case.read,moderation.decision.execute`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "审核决策复核",
    "group": "审核与客服"
  },
  {
    "id": "SC-ADMIN-023",
    "path": "/moderation/appeals",
    "endpoints": [
      "GET /admin/v1/moderation-appeals"
    ],
    "actions": [
      "moderation.appeal.read"
    ],
    "fields": "strict status/stage/risk/severity/assignment/source-case-SLA filters；filter-bound cursor；appeal id/status/server-derived stage/relative assignment/current evidence version；safe source case id/object/risk/severity/status/SLA/version/ETag；exclusion_count=2/digest/valid；appeal version/ETag/action",
    "behavior": "bounded query；服务端逐候选从 source executed decision 重建 proposer+reviewer expected set，对比全部 exclusion row/source link/digest，任一不完整整页503；全集有效后排除无 exact scope 或当前 principal 命中全集的行；隐藏满页仍返回原始扫描 cursor；Open 仅 valid+row/session exact read authority并只导航生成详情路由",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "401/403/410、400/409、503、permission epoch/action/data scope/temporary grant变化立即 abort并清列表/cursor；普通网络错误才可短暂 cached；集合不完整进入事故且不按单一 reviewer 猜测；空 items+has_more 继续加载；退出回 moderation",
    "roles": "risk_reviewer/lead；`moderation.appeal.read`",
    "testIds": [
      "T-OPS-001"
    ],
    "title": "申诉队列",
    "group": "审核与客服"
  },
  {
    "id": "SC-ADMIN-024",
    "path": "/moderation/appeals/:id",
    "endpoints": [
      "GET /admin/v1/moderation-appeals/{id}",
      "PUT /admin/v1/moderation-appeals/{id}/assignee",
      "POST /admin/v1/moderation-appeals/{id}/decisions"
    ],
    "actions": [
      "moderation.appeal.read",
      "moderation.appeal.assign",
      "moderation.appeal.decide"
    ],
    "fields": "closed appeal id/status/stage/relative assignment；safe source case metadata+ETag；original effect kind/decision/restriction state/version；current evidence version+每版 count/bytes/time；exclusion count/roles/digest/valid；最近100条无身份 decision no/stage/evidence/result version/time+truncated；appeal version/ETag/allowed actions/server `allowed_decision_stages`",
    "behavior": "query；进入先刷新 session 再 GET；Assign 只显示“分配给我”，body target 取当前 session 内存且不渲染/持久化，submitted+lead+target current read/decide exact scope+exclusion valid+ETag；Decide 只渲染服务端 stages，`request_evidence` 允许 under_review/escalated，`escalate` 仅 under_review，`uphold` 允许 under_review/escalated且用 HighRiskGuardForm；`modify/overturn` effect authority 未冻结时服务端不返回且固定503零写",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "load/mutation/authority 三类 AbortController；409 清草稿/step-up并强制重读；401/403/404/410/503、permission epoch/action/scope/route变化及离页 abort并清详情、草稿、step-up；普通 offline 只可保留 metadata 且禁 mutation；空 stages 不显示占位按钮；退出回 appeals",
    "roles": "risk_reviewer/lead；`moderation.appeal.read,moderation.appeal.assign,moderation.appeal.decide`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "申诉详情",
    "group": "审核与客服"
  },
  {
    "id": "SC-ADMIN-025",
    "path": "/support/tickets",
    "endpoints": [
      "GET /admin/v1/support/tickets"
    ],
    "actions": [
      "support.ticket.read"
    ],
    "fields": "filters/cursor/queue/priority/SLA/status/assignee/version",
    "behavior": "query；Open ticket",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "scope 变化清行；退出回 overview",
    "roles": "support/privacy；`support.ticket.read`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "客服工单",
    "group": "审核与客服"
  },
  {
    "id": "SC-ADMIN-026",
    "path": "/support/tickets/:id",
    "endpoints": [
      "GET /admin/v1/support/tickets/{id}",
      "POST /admin/v1/support/tickets/{id}/messages",
      "PUT /admin/v1/support/tickets/{id}/assignee",
      "PATCH /admin/v1/support/tickets/{id}/triage",
      "POST /admin/v1/support/tickets/{id}/escalations",
      "POST /admin/v1/support/tickets/{id}/internal-notes",
      "POST /admin/v1/support/tickets/{id}/closures",
      "POST /admin/v1/support/tickets/{id}/attachment-reveals",
      "POST /admin/v1/support/tickets/{id}/resource-links",
      "DELETE /admin/v1/support/tickets/{id}/resource-links/{link_id}",
      "PUT /admin/v1/support/tickets/{id}/tags",
      "POST /admin/v1/support/ticket-messages/{id}/translations",
      "GET /admin/v1/account-recovery-cases/{id}",
      "POST /admin/v1/account-recovery-cases/{id}/verification-decisions",
      "POST /admin/v1/account-recovery-cases/{id}/completions"
    ],
    "actions": [
      "support.ticket.read",
      "support.ticket.write",
      "support.ticket.assign",
      "support.ticket.triage",
      "support.ticket.escalate",
      "support.ticket.internal_note",
      "support.ticket.close",
      "support.ticket.translate",
      "support.private_attachment.reveal",
      "account.recovery.verify",
      "account.recovery.complete"
    ],
    "fields": "ticket/timeline/user-family-order typed links/tags/templates/attachments/translations/CSAT/assignee/SLA；recovery method/decision/completion operation",
    "behavior": "query ticket/recovery；link/unlink/tag；Translate=grant+locale；Verify 冻结 method；Complete=verified decision+identity digest+不同执行人",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "translation 不覆盖原文；CSAT只读；404 recovery 不影响工单；identity/digest/grant stale 零绑定；409 diff；退出清敏感 evidence",
    "roles": "support/lead/privacy/security_admin/account_reviewer；`support.ticket.read,support.ticket.write,support.ticket.assign,support.ticket.triage,support.ticket.escalate,support.ticket.internal_note,support.ticket.close,support.ticket.translate,support.private_attachment.reveal,account.recovery.verify,account.recovery.complete`",
    "testIds": [
      "T-OPS-006",
      "T-PRV-001"
    ],
    "title": "工单详情",
    "group": "审核与客服"
  },
  {
    "id": "SC-ADMIN-027",
    "path": "/notification-campaigns",
    "endpoints": [
      "GET /admin/v1/notification-campaigns",
      "POST /admin/v1/notification-campaigns",
      "POST /admin/v1/notification-campaigns/{id}/validations",
      "POST /admin/v1/notification-campaigns/{id}/send-approvals",
      "POST /admin/v1/notification-campaigns/{id}/stops",
      "GET /admin/v1/notification-reprocess-requests",
      "POST /admin/v1/notification-deliveries/{id}/reprocess-requests",
      "POST /admin/v1/notification-reprocess-requests/{id}/approvals"
    ],
    "actions": [
      "notification.campaign.read",
      "notification.campaign.write",
      "notification.campaign.send",
      "kill_switch.execute",
      "notification.reprocess.read",
      "notification.reprocess.propose",
      "notification.reprocess.approve"
    ],
    "fields": "tabs campaigns/reprocess；campaign audience/template/approvals/batches；recipient immutable root/outcome/delivery origin；counter replay diff；reprocess request/source fact hash/new delivery reverse decision/device/preference/privacy epoch",
    "behavior": "query campaigns/reprocess；Create/Validate/Send/Stop 按 registry；Reprocess propose=单 delivery+dry-run+expected epoch+reason；Approve=非 proposer+source/current reducer diff 未变+step-up",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "已发 campaign 不可撤回；outcome/counter mismatch 标事故且禁止手改；sent 无唯一 campaign delivery、skip/fail 带 delivery 或 reprocess delivery 无反向 decision 均 fail closed；变化时重做 dry-run；退出保留 operation ID",
    "roles": "product/ops/auditor/ops_reviewer；`notification.campaign.read,notification.campaign.write,notification.campaign.send,kill_switch.execute,notification.reprocess.read,notification.reprocess.propose,notification.reprocess.approve`",
    "testIds": [
      "T-OPS-006",
      "T-PLT-002"
    ],
    "title": "通知活动",
    "group": "内容与数据"
  },
  {
    "id": "SC-ADMIN-028",
    "path": "/announcements",
    "endpoints": [
      "GET /admin/v1/announcements",
      "POST /admin/v1/announcements",
      "PATCH /admin/v1/announcements/{id}"
    ],
    "actions": [
      "config.read",
      "config.draft.write"
    ],
    "fields": "filters/key/locale/version/body/deeplink/schedule/status/ETag",
    "behavior": "query；Create=versioned DTO valid；Save=editable+ETag；发布跳 config review/release",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "409 diff；locale 缺失阻断提交；退出保留草稿",
    "roles": "product/content/ops；`config.read,config.draft.write`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "公告管理",
    "group": "内容与数据"
  },
  {
    "id": "SC-ADMIN-029",
    "path": "/client-versions",
    "endpoints": [
      "GET /admin/v1/client-versions",
      "POST /admin/v1/client-versions",
      "PATCH /admin/v1/client-versions/{id}"
    ],
    "actions": [
      "version.read",
      "version.release.write"
    ],
    "fields": "platform/min/recommended/forced/store links/regions/status/ETag",
    "behavior": "query；Create/Save=兼容矩阵+有效链接+step-up+ETag",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "兼容失败禁发布；409 diff；退出丢未保存 patch",
    "roles": "ops/content/support；`version.read,version.release.write`",
    "testIds": [
      "T-OPS-003"
    ],
    "title": "客户端版本",
    "group": "内容与数据"
  },
  {
    "id": "SC-ADMIN-030",
    "path": "/resource-releases",
    "endpoints": [
      "GET /admin/v1/resource-releases",
      "POST /admin/v1/resource-releases"
    ],
    "actions": [
      "version.read",
      "version.release.write"
    ],
    "fields": "manifest/hash/CDN/region probes/client range/status/operation",
    "behavior": "query；Create=hash+全区域 probe+兼容通过+step-up",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "probe 失败不发布；operation 可离页；退出回 versions",
    "roles": "ops/content/support；`version.read,version.release.write`",
    "testIds": [
      "T-OPS-003"
    ],
    "title": "资源发布",
    "group": "内容与数据"
  },
  {
    "id": "SC-ADMIN-031",
    "path": "/metrics/:key",
    "endpoints": [
      "GET /admin/v1/metrics/{key}",
      "GET /admin/v1/metric-definitions",
      "POST /admin/v1/metric-definition-drafts"
    ],
    "actions": [
      "analytics.read",
      "analytics.definition.write"
    ],
    "fields": "metric key/definition/version/status/owner/cohort/window/time zone/numerator/denominator/allowed dimensions/latency/small-sample threshold/target-warn-stop；range/series/delay/suppression",
    "behavior": "query metric/definition list；New definition=typed source refs 可编译+维度 allowlist+owner/latency/threshold 完整+step-up，提交后进入 config 双审",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "source 悬空/任意 DSL/时区或分母错误阻断草稿；429 缩范围；小样本 suppressed；定义切换保留旧报表版本；退出保留服务端草稿",
    "roles": "analyst/product/ops；`analytics.read,analytics.definition.write`",
    "testIds": [
      "T-OPS-003"
    ],
    "title": "指标详情",
    "group": "内容与数据"
  },
  {
    "id": "SC-ADMIN-032",
    "path": "/experiments",
    "endpoints": [
      "GET /admin/v1/experiments",
      "POST /admin/v1/experiments",
      "PATCH /admin/v1/experiments/{id}"
    ],
    "actions": [
      "analytics.read",
      "experiment.write"
    ],
    "fields": "filters/cursor/hypothesis/layer/unit/audience/variants/metrics/guards/status/results/version",
    "behavior": "query；Create=字段完整+禁用项扫描；Save=ETag+运行中字段 allowlist",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "guard fail 不启动；409 diff；退出保留服务端版本",
    "roles": "product/analyst；`analytics.read,experiment.write`",
    "testIds": [
      "T-OPS-005"
    ],
    "title": "实验管理",
    "group": "内容与数据"
  },
  {
    "id": "SC-ADMIN-033",
    "path": "/privacy-requests",
    "endpoints": [
      "GET /admin/v1/privacy-requests"
    ],
    "actions": [
      "privacy.request.read"
    ],
    "fields": "filters/cursor/type/status/deadline/holds/domain steps/version",
    "behavior": "query；Open request",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "deadline 始终显示；scope 变化清行；退出回 overview",
    "roles": "privacy；`privacy.request.read`",
    "testIds": [
      "T-PRV-004"
    ],
    "title": "隐私请求",
    "group": "隐私与安全"
  },
  {
    "id": "SC-ADMIN-034",
    "path": "/privacy-requests/:id",
    "endpoints": [
      "GET /admin/v1/privacy-requests/{id}",
      "POST /admin/v1/privacy-request-steps/{id}/retries",
      "POST /admin/v1/privacy-requests/{id}/proof-exports"
    ],
    "actions": [
      "privacy.request.read",
      "privacy.step.retry",
      "privacy.proof.export"
    ],
    "fields": "request/domains/holds/step status/lease/version/deadline/proof fields",
    "behavior": "query；Retry=failed step+grant+reason；Export=completed facts+fields+purpose+step-up",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "lease conflict 等待/刷新；成功域 no-op；proof URL 到期清除；退出回 list",
    "roles": "privacy/auditor；`privacy.request.read,privacy.step.retry,privacy.proof.export`",
    "testIds": [
      "T-PRV-004"
    ],
    "title": "隐私请求详情",
    "group": "隐私与安全"
  },
  {
    "id": "SC-ADMIN-035",
    "path": "/access-grants",
    "endpoints": [
      "GET /admin/v1/access-grants",
      "POST /admin/v1/access-grants",
      "POST /admin/v1/access-grants/{id}/approvals",
      "DELETE /admin/v1/access-grants/{id}"
    ],
    "actions": [
      "role.read",
      "access.grant.request",
      "access.grant.approve",
      "access.grant.revoke"
    ],
    "fields": "filters/cursor/action/resource/field classes/purpose/ticket/ttl/requester/approver/admin session digest status/expiry/masked scope",
    "behavior": "query；Request=typed action/resource/ticket+TTL；Approve/Reject=非申请人+active admin session；Revoke=active+reason+独立 action",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "任一 principal/action/ticket/session FK 或 epoch 失效 fail closed；到期/revoke 清敏感缓存；退出回 overview",
    "roles": "authorized/privacy/security_admin/auditor；`role.read,access.grant.request,access.grant.approve,access.grant.revoke`",
    "testIds": [
      "T-OPS-001"
    ],
    "title": "临时授权",
    "group": "隐私与安全"
  },
  {
    "id": "SC-ADMIN-036",
    "path": "/roles",
    "endpoints": [
      "GET /admin/v1/roles",
      "POST /admin/v1/roles",
      "PATCH /admin/v1/roles/{id}",
      "POST /admin/v1/role-change-requests/{id}/approvals",
      "GET /admin/v1/principal-role-change-requests",
      "POST /admin/v1/principal-role-change-requests",
      "POST /admin/v1/principal-role-change-requests/{id}/approvals",
      "GET /admin/v1/principals",
      "POST /admin/v1/principals/{id}/suspensions",
      "POST /admin/v1/principals/{id}/reactivation-requests",
      "POST /admin/v1/principal-reactivation-requests/{id}/approvals"
    ],
    "actions": [
      "role.read",
      "role.write",
      "role.approve",
      "principal.read",
      "principal.suspend",
      "principal.reactivate"
    ],
    "fields": "tabs roles/principals/grants；role/principal change request proposer、approval actor/session epoch、decision source；principal status/epoch/active role+grant+session counts；reactivation security+IAM 双角色证据",
    "behavior": "query；Create/Save/Grant/Revoke只生成 request；Approve/Reject=非 proposer+本人 step-up session/current epoch；Reactivate=两角色不同 principal 且旧 role/grant/session 全0",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "自审、zero/wrong approval、actor/session/epoch mismatch、同人双角色或 stale 立即清决定并重拉；suspend epoch+1撤销三类；恢复成功后清 Pinia/重新登录并另走最小授权",
    "roles": "security_admin/security_reviewer/iam_owner/auditor；`role.read,role.write,role.approve,principal.read,principal.suspend,principal.reactivate`",
    "testIds": [
      "T-OPS-001",
      "T-OPS-006"
    ],
    "title": "角色与人员",
    "group": "隐私与安全"
  },
  {
    "id": "SC-ADMIN-037",
    "path": "/audit-events",
    "endpoints": [
      "GET /admin/v1/audit-events",
      "POST /admin/v1/audit-exports"
    ],
    "actions": [
      "audit.read",
      "audit.export"
    ],
    "fields": "principal/action/exact resource/ticket/result/from-to<=31d/cursor/events/query_digest/field classes/chain verification/export status",
    "behavior": "query 必须至少一个 exact index anchor；每页逐条链验证；Export=服务端返回过的 query_digest+fields+purpose+step-up",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "过宽/无锚点查询本地阻断；断链/闭包异常清结果并显示 authority failure；export operation 可离页；退出清结果/query digest",
    "roles": "auditor；`audit.read,audit.export`",
    "testIds": [
      "T-OPS-002"
    ],
    "title": "审计事件",
    "group": "隐私与安全"
  },
  {
    "id": "SC-ADMIN-038",
    "path": "/audit-daily-heads/:date",
    "endpoints": [
      "GET /admin/v1/audit-daily-heads/{date}",
      "POST /admin/v1/audit-daily-heads/{date}/seal-retries",
      "POST /admin/v1/audit-seal-retry-requests/{id}/approvals"
    ],
    "actions": [
      "audit.read",
      "audit.daily_seal.retry"
    ],
    "fields": "date/status/last_seq/record_count/root_digest/kms_key_version/signature_verification/worm_object_version/最近100 seal attempts/最近20 retry requests+approval/version/chain head verification",
    "behavior": "query 先写审计再校验 head/最后 record/root；sealed 只接受服务端真实 KMS+WORM verified；Retry propose=状态 `sealing,verification_failed`+incident+expected_last_seq/current ETag+reason+step-up；Approve/Reject=不同 principal+互补 auditor/security_admin+request current version+step-up",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "KMS/WORM authority 未配置则 mutation 路由不注册，查 sealed 时显示 error 而非 verified；seq/root/chain 冲突清 head；未双审只显示 queued；新 attempt 只追加不覆盖旧证据；退出回 audit",
    "roles": "auditor/security_admin；`audit.read,audit.daily_seal.retry`",
    "testIds": [
      "T-OPS-002"
    ],
    "title": "每日审计根",
    "group": "隐私与安全"
  },
  {
    "id": "SC-ADMIN-039",
    "path": "/kill-switches",
    "endpoints": [
      "GET /admin/v1/kill-switches",
      "GET /admin/v1/kill-switch-snapshots/current",
      "POST /admin/v1/kill-switches/{key}/executions",
      "POST /admin/v1/kill-switch-executions/{id}/reviews",
      "POST /admin/v1/kill-switches/{key}/recovery-requests",
      "POST /admin/v1/kill-switch-recovery-requests/{id}/approvals"
    ],
    "actions": [
      "kill_switch.read",
      "kill_switch.execute",
      "kill_switch.review",
      "kill_switch.recover"
    ],
    "fields": "scope/key/current state/execution/review due/review evidence/recovery request+双审批/expiry/incident/condition/probe/signed snapshot sequence+TTL+edge verification/version",
    "behavior": "query；Disable=incident+scope+expiry+step-up 后立即写 execution/snapshot；Review=非执行人24h ratify/reject；Recover=先 proposal，再 incident commander+domain owner 非 proposer双审",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "补审超时/拒绝仍保持关闭；snapshot 过期/验签失败/sequence 回退显示 edge fail-closed；condition/probe/state 变化 recovery stale；409 刷新",
    "roles": "ops/incident_commander/domain_owner/security_reviewer/auditor；`kill_switch.read,kill_switch.execute,kill_switch.review,kill_switch.recover`",
    "testIds": [
      "T-OPS-006"
    ],
    "title": "紧急开关",
    "group": "隐私与安全"
  },
  {
    "id": "SC-ADMIN-040",
    "path": "/content/event-schemas",
    "endpoints": [
      "GET /admin/v1/domain-event-schemas",
      "POST /admin/v1/domain-event-schema-drafts"
    ],
    "actions": [
      "content.event_schema.read",
      "content.event_schema.write"
    ],
    "fields": "event_type/version/producer/aggregate/compatibility/fields(path,type,required,pii,semantic)/enums/status/reference_counts/diff",
    "behavior": "query；New version=base published+backward compatibility+全部字段/enum typed；Submit draft 仍跳 config validate/review/release",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "incompatible/missing producer/field referenced 定位 diff；已发布只读；退出保留服务端草稿",
    "roles": "content/ops/auditor/platform_reviewer；`content.event_schema.read,content.event_schema.write`",
    "testIds": [
      "T-CONTENT-001"
    ],
    "title": "事件协议",
    "group": "平台"
  },
  {
    "id": "SC-ADMIN-041",
    "path": "/economy/soft-currency-offers",
    "endpoints": [
      "GET /admin/v1/soft-currency-offers",
      "POST /admin/v1/soft-currency-offer-drafts"
    ],
    "actions": [
      "economy.soft_offer.read",
      "economy.soft_offer.write"
    ],
    "fields": "offer/version/target asset/price/quantity/owner/region/limit/status/catalog/economy impact",
    "behavior": "query；New version=target 精确命中 D16 48 offer（17 furniture+11 decor+10 food+5 toy+5 wearable）之一+正价格/量+typed region/limit+产品财务双审路径",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "48 集合/资产/价格/量/region/limit 不闭合禁提交；旧版本只读；退出保留服务端草稿",
    "roles": "product/finance/ops；`economy.soft_offer.read,economy.soft_offer.write`",
    "testIds": [
      "T-ECO-001"
    ],
    "title": "软货币商品",
    "group": "平台"
  },
  {
    "id": "SC-ADMIN-042",
    "path": "/economy/system-free-refill-policies",
    "endpoints": [
      "GET /admin/v1/system-free-refill-policies",
      "POST /admin/v1/system-free-refill-policy-drafts"
    ],
    "actions": [
      "economy.refill_policy.read",
      "economy.refill_policy.write"
    ],
    "fields": "policy/version/asset/threshold/refill_to/daily_limit/day_boundary/grant_rate/ledger metrics/status",
    "behavior": "query；New version=仅 oat/berry+threshold=3+refill_to=3+daily=1+user_time_zone+防领养日叠加模拟",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "第三资产/阈值漂移/叠加 replay 失败即禁提交；退出保留服务端草稿",
    "roles": "product/ops；`economy.refill_policy.read,economy.refill_policy.write`",
    "testIds": [
      "T-ECO-001"
    ],
    "title": "免费补充策略",
    "group": "平台"
  },
  {
    "id": "SC-ADMIN-043",
    "path": "/commerce/capability-bundles",
    "endpoints": [
      "GET /admin/v1/capability-bundles",
      "POST /admin/v1/capability-bundle-drafts",
      "GET /admin/v1/bundle-completion-offers",
      "POST /admin/v1/bundle-completion-offer-drafts"
    ],
    "actions": [
      "commerce.capability.read",
      "commerce.capability.write",
      "commerce.bundle_completion.read",
      "commerce.bundle_completion.write"
    ],
    "fields": "tabs entitlement graph/bundle completion；8 capability/free/member/fallback/plan/SKU/platform/trial/rights；completion bundle/owned/missing/upgrade SKU/region/price book/eligibility schema/status",
    "behavior": "query；New entitlement version 按既有闭包；New completion offer=owned+missing精确等于原 bundle、completion SKU fulfillment=missing、真实平台映射+产品财务双审",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "family/缺项/fallback不等 free/映射断裂禁提交；completion 集重叠/缺件/伪 product/不支持地区拒绝；退款历史只读",
    "roles": "product/finance/support；`commerce.capability.read,commerce.capability.write,commerce.bundle_completion.read,commerce.bundle_completion.write`",
    "testIds": [
      "T-COM-003"
    ],
    "title": "商业能力包",
    "group": "平台"
  },
  {
    "id": "SC-ADMIN-044",
    "path": "/ai/quota-policies",
    "endpoints": [
      "GET /admin/v1/ai/quota-policies",
      "POST /admin/v1/ai/global-quota-policy-drafts",
      "POST /admin/v1/ai/quota-policy-drafts"
    ],
    "actions": [
      "ai.quota.read",
      "ai.quota.write"
    ],
    "fields": "tabs shared global/scene policies；version/free_or_member/window/USD usd_microunit/request/input/output/cost ceiling/scene/family/user limits/current aggregate/budget simulation/submission status",
    "behavior": "query；Create global=首个版本允许但不超过 D16 seed；scene version=当前 shared global published+三层完整；全部走 immutable submission+AI safety/finance 双审",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "shared global 缺失/失效、单位非 USD microunit、缺层、超预算或窗口不闭合禁提交；不展示 prompt/正文/用户明细；退出保留草稿",
    "roles": "ai_safety/ops/finance；`ai.quota.read,ai.quota.write`",
    "testIds": [
      "T-MEM-003"
    ],
    "title": "AI 配额",
    "group": "AI"
  },
  {
    "id": "SC-ADMIN-045",
    "path": "/outbox-events",
    "endpoints": [
      "GET /admin/v1/outbox-events",
      "GET /admin/v1/outbox-repair-requests/{id}",
      "POST /admin/v1/outbox-events/{id}/repairs",
      "POST /admin/v1/outbox-repair-requests/{id}/approvals",
      "GET /admin/v1/dr/reconciliation-runs",
      "GET /admin/v1/dr/reconciliation-runs/{id}",
      "POST /admin/v1/dr/reconciliation-runs",
      "POST /admin/v1/dr/reconciliation-runs/{id}/verifications"
    ],
    "actions": [
      "platform.outbox.read",
      "platform.outbox.repair",
      "platform.dr.read",
      "platform.dr.reconcile"
    ],
    "fields": "tabs Outbox/DR reconcile；Outbox bounded head/schema/hash/dead_at/repair decision source；DR incident/fencing/journal watermark/replica GTID/run/items/receipt digest/subject HMAC/deny projection/counts/verification",
    "behavior": "Replay/Supersede 仅 dead head+真审批并显示 event 反向 source；DR Start/Verify 同前",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "历史 dead 行无 exact replay/supersede source 禁止变更；stale 不改 event；DR commit 缺失只可原 key replay，prepare-only/epoch unproven 保持 blocked；operation 可离页",
    "roles": "ops/db_sre/security_admin/auditor/platform_reviewer；`platform.outbox.read,platform.outbox.repair,platform.dr.read,platform.dr.reconcile`",
    "testIds": [
      "T-OPS-004"
    ],
    "title": "Outbox 与灾备",
    "group": "平台"
  },
  {
    "id": "SC-ADMIN-046",
    "path": "/ai/content-controls",
    "endpoints": [
      "GET /admin/v1/ai/content-control-requests",
      "POST /admin/v1/ai/content-control-requests",
      "POST /admin/v1/ai/content-control-requests/{id}/approvals"
    ],
    "actions": [
      "ai.content_control.read",
      "ai.content_control.propose",
      "ai.content_control.approve"
    ],
    "fields": "filters/cursor/request/scope/type/reason/item hashes/dry-run/source/ACL/privacy epochs/proposer/approvals/executed decision；item terminal decision source；实时 outcome counts",
    "behavior": "query；Propose=精确 scope+dry-run item 非空；Approve=非 proposer+每项 current+step-up；terminal item 必须同 request executed decision，数量仅从 item COUNT",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "无 execution source 的 terminal item、任意 summary count、epoch/ACL/item 集变化均 fail closed；部分失败逐 item 留证据，不直接编辑生成物；operation 可离页；退出清 reveal/明细缓存",
    "roles": "ai_safety/risk/auditor/reviewer；`ai.content_control.read,ai.content_control.propose,ai.content_control.approve`",
    "testIds": [
      "T-MEM-003",
      "T-OPS-006"
    ],
    "title": "AI 内容控制",
    "group": "AI"
  },
  {
    "id": "SC-ADMIN-047",
    "path": "/knowledge/articles",
    "endpoints": [
      "GET /admin/v1/knowledge/articles",
      "GET /admin/v1/knowledge/articles/{id}",
      "POST /admin/v1/knowledge/articles",
      "POST /admin/v1/knowledge/articles/{id}/versions",
      "POST /admin/v1/knowledge/article-versions/{id}/publications",
      "POST /admin/v1/knowledge/article-versions/{id}/impact-marks"
    ],
    "actions": [
      "support.knowledge.read",
      "support.knowledge.write",
      "support.knowledge.publish"
    ],
    "fields": "article/version/localizations/keywords/feedback；platform/country/client range applicability；typed feature/config links/impact status/release/legal review",
    "behavior": "query list/detail；Create/New version 同时提交 applicability+links；Publish 阻断重叠/悬空；Impact mark 只改 link review state",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "config release 命中自动 review_required；受影响文章不可作为 current 帮助返回；正文不可原地改；409 重读",
    "roles": "support/content/product/content_reviewer；`support.knowledge.read,support.knowledge.write,support.knowledge.publish`",
    "testIds": [
      "T-OPS-006",
      "T-I18N-001"
    ],
    "title": "知识库",
    "group": "审核与客服"
  },
  {
    "id": "SC-ADMIN-048",
    "path": "/orders",
    "endpoints": [
      "GET /admin/v1/orders",
      "GET /admin/v1/provider-notifications",
      "GET /admin/v1/provider-notifications/{id}",
      "POST /admin/v1/provider-notifications/{id}/reprocess-requests",
      "POST /admin/v1/provider-notification-reprocess-requests/{id}/approvals"
    ],
    "actions": [
      "commerce.order.read",
      "commerce.provider_notification.read",
      "commerce.provider_notification.reprocess"
    ],
    "fields": "order filters/result cursor；provider notification digest/status/error/mapping；reprocess request/dry-run/approvals/attempts/operation",
    "behavior": "query orders/notifications/detail；Reprocess=单 source+ticket+dry-run；Approve=非 proposer+digest/current reducer head",
    "states": "`Y/Y/Y/Y/Y/Y/Y/Y/Y/Y/Y`",
    "recovery": "无 order mapping 的 notification 仍可定位；原 payload/status 永不改；stale/duplicate 可恢复；operation 可离页；退出清交易搜索条件",
    "roles": "finance/support_lead/auditor/payment_reviewer；`commerce.order.read,commerce.provider_notification.read,commerce.provider_notification.reprocess`",
    "testIds": [
      "T-COM-001",
      "T-COM-003",
      "T-OPS-006"
    ],
    "title": "订单与平台通知",
    "group": "商业"
  }
] as const

export type AdminContract = (typeof adminContracts)[number]
export function getAdminContract(id: string): AdminContract {
  const contract = adminContracts.find((item) => item.id === id)
  if (!contract) throw new Error(`Unknown admin contract: ${id}`)
  return contract
}
